import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

import { toast } from 'react-toastify';
import { useState } from 'react';
import { Link as RouterLink, useLocation, useParams, useNavigate, useNavigation } from 'react-router-dom';
import { Box, Button, Card, Container, Fab, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography, Checkbox, CardContent } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon, Padding } from '@mui/icons-material'
import { authKey, BaseURL } from '../../common/URLs';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { HELPDESK_ROLES } from '../../common/constants';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { loaderService } from '../../common/custom-loader/loader-service';
import { VALIDATION } from '../../common/commonValidations';
import apiClient from '../../axios';

function AddEdituserPage() {
    const location = useLocation();
    const auth = 'Bearer ' + getLocalStorageItem('id_token');
    const [Flag, setFlag] = useState(null)
    const [respData, setRespData] = useState([]);
    const navigate = useNavigate();

    // /////////////////  question //////////////////
    const [first, setfirst] = useState('');
    const [second, setsecond] = useState('');
    const [last, setlast] = useState('');
    // const [address, setaddress] = useState('');
    const [mobile, setmobile] = useState('');
    const { id } = useParams();
    const [categories, setCategories] = useState([]);
    const [enable, setenable] = useState(false);
    const [Regsuserdetails, setRegsuserdetails] = useState([]);
    const [usertype, setusertype] = useState('');
    const [useremail, setUseremail] = useState("");
    const [totalinfo, settotalinfo] = useState('');
    const [selectedindex, setselectedindex] = useState('');
    const [alluseremail, setalluseremail] = useState([]);
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const [logConfirmModalOpen1, setLogConfirmModalOpen1] = useState(false);
    const handleConfirmLogModalOpen1 = () => setLogConfirmModalOpen1(true);
    const handleConfirmLogModalClose1 = () => setLogConfirmModalOpen1(false);
    const [isApiCalled, setIsApiCalled] = useState(false);

    const handleCategoryChange = (e) => {
        const { target: { value } } = e;
        setCategories(
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleChangechekbox = (e) => {
        let det = Regsuserdetails[e.target.value];
        const faqDetails1 = alluseremail.find(item => (item.emailId === det.emailAddress))
        if (faqDetails1) {
            toast.error('User is already present  you can only edit!');
            navigate('../manage-helpdesk-user')
        }
        setselectedindex(e.target.value)
        settotalinfo(Regsuserdetails[e.target.value])
    }

    const handleUser_type = (e) => {
        UserDetails(e.target.value);
        setusertype(e.target.value);
    }

    useEffect(() => {
        fetchCatagory();
        allusers()
    }, [])

    useEffect(() => {
        if (id && id.length > 0) {
            managefaquser();
        }
    }, [id])


    //fetchCategoryAndSubcategory API
    const fetchCatagory = () => {
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchCategoryAndSubcategory",
            {},
            {
                headers: {
                    "Authorization": auth,
                    "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? true : false
                },
            }
        ).then((response) => {
            // console.log("Success - ", response);
            setRespData(response.data);
            console.log(respData, "responseData");
            loaderService.hideLoader();
        }).catch((error) => {
            console.log("Error - " + error);
            loaderService.hideLoader();
        })
    }

    const UserDetails = (usercategory) => {
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/registration/v1/User/get_user_by_roles",
            {
                "roleName": usercategory
            },
            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            setRegsuserdetails(response.data.users);
            loaderService.hideLoader();
        }).catch((error) => {
            console.log("Error - " + error);
            loaderService.hideLoader();
        })
    }

    //edity API
    const allusers = () => {
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpDeskTeamMem",
            {},
            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            console.log("Success - ", response.data);
            if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser) {
                let data = response.data.filter(item => item.extFlag === 1);
                setalluseremail(data)
            }
            else {
                let data = response.data.filter(item => item.extFlag === 0);
                setalluseremail(data)
            }
            loaderService.hideLoader();
        }).catch((error) => {
            console.log("Error - " + error);
            loaderService.hideLoader();
        })
    }

    const managefaquser = () => {
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchUserDtlById",
            { "fetchById": id  },
            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            setfirst(response.data.firstName);
            setsecond(response.data.middleName);
            setlast(response.data.lastName);
            setCategories(response.data.userCategoryList?.map(i => i.grievanceCategory));
            setusertype(response.data.userType)
            setenable(true)
            setmobile(response.data.mobile);
            setUseremail(response.data.emailId);
            // setaddress(response.data.address);
            setFlag(response.data);
        }).catch((error) => {
            console.log("Error - " + error);
        })
    }

    //edity API

    // const onConfirmUpdate = () => {
    //     handleConfirmLogModalClose1();
    //     editrequest();
    // }

    const onConfirmUpdate = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await editrequest();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen1(false);
            setIsApiCalled(false);
        }
    };

    const editrequest = () => {
        const userCategoryList1 = categories.map(i => { return { grievanceCategory: i } });
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/editExistingHelpDeskTeamMemById",
            {
                "id": id,
                "mobile": mobile,
                "firstName": first,
                "middleName": second,
                "lastName": last,
                // "address": address,
                "userType": usertype,
                "emailId": useremail,
                "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0,
                "userCategoryList": userCategoryList1,

            },
            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description);
            navigate('../manage-helpdesk-user')
        }).catch((error) => {
            console.log("Error - " + error);
        })
    }


    const adddata = () => {
        const userCategoryList = categories.map(i => { return { "grievanceCategory": i } });
        let onSaveForm = {
            "mobile": totalinfo.mobileNo,
            "firstName": totalinfo.firstname,
            "middleName": totalinfo.middlename,
            "lastName": totalinfo.lastname,
            // "address": address,
            "userType": usertype,
            "emailId": totalinfo.emailAddress,
            "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0,
            "userCategoryList": userCategoryList
        }
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/addNewHelpDeskTeamMem",
            onSaveForm,
            {
                headers: {

                    "Authorization": auth
                },
            }
        ).then((response) => {
            response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description);
            navigate('../manage-helpdesk-user')
            setRespData(response.data)
            loaderService.hideLoader();
        }).catch((error) => {
            console.log(error);
            toast.error('Please try again !');
            loaderService.hideLoader();
        })
    }

    // const onConfirmSubmit = () => {
    //     handleConfirmLogModalClose();
    //     adddata()
    // }

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await adddata();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen(false);
            setIsApiCalled(false);
        }
    };
console.log("selectedindex", selectedindex)
    function submit() {
        if (Flag !== null) {
            handleConfirmLogModalOpen1();
        }
        else {
            if(!usertype) {
                toast.error('Please select user type')
            }
            else if(selectedindex === '') {
                toast.error('Please select from user list')
            }
            else if (categories?.length === 0 ) {
                toast.error('Please select category')
            }
            // else if (!address) {
            //     toast.error('Please enter address')
            // }
            else {               
                handleConfirmLogModalOpen();
            }
        }
    }

    const categoryList = localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? respData?.External_category : respData?.Helpdesk_category

    // const onAddressChange = (e) => {
    //     setaddress(VALIDATION.noSpecialCharacterValidation(e.target.value).slice(0, 200))
    // }

    return (
        <>
            <Helmet>
                <title> ManageHelpDesk edit/add </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='../manage-helpdesk-user' size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>  Manage HelpDesk User
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                                <FormControl fullWidth >
                                    <InputLabel>User Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={usertype}
                                        label="User_type"
                                        onChange={handleUser_type}
                                    >
                                        {localStorage.getItem("role") === "GHD-Incharge" ? (
                                            <MenuItem value="GHD-SupportExecutive">Helpdesk Support Executive</MenuItem>
                                        ) : localStorage.getItem("role") === "GHD-ExtAdminUser" ? (
                                            <MenuItem value="GHD-ExtSupportExecutive">External Helpdesk Support Executive</MenuItem>
                                        ) : (
                                            <MenuItem value="GHD-SupportExecutive">Helpdesk Support Executive</MenuItem> // Optional fallback
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {!enable && (
                                <Grid item xs={12} lg={6}>
                                    <>
                                        <FormControl fullWidth >
                                            <InputLabel id="demo-multiple-chip-label">User List</InputLabel>
                                            <Select
                                                labelId="select-user"
                                                id="select-user"
                                                label="User List"
                                                value={selectedindex}
                                                onChange={(event) => handleChangechekbox(event)}
                                            >
                                                {Regsuserdetails.map(function (item, i) {
                                                    return <MenuItem key={i} value={i}>
                                                        {/* <Checkbox onClick={(e) => handleChangechekbox(e, item)} /> */}
                                                        {item.emailAddress}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl>
                                    </>
                                </Grid>
                            )}
                            {enable && (
                                <Grid item xs={12} lg={6}>
                                    <TextField fullWidth id="outlined-controlled" label="userList" disabled value={useremail} />
                                </Grid>
                            )}
                            <Grid item xs={12} lg={6}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-multiple-chip-label" >Catagory</InputLabel>
                                    <Select
                                        label="Category"
                                        labelId="demo-multiple-chip-label"
                                        id="demo-multiple-chip"
                                        multiple
                                        value={categories}
                                        onChange={handleCategoryChange}
                                        //onClick={() => fetchCategory()}
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} />
                                                ))}
                                            </Box>
                                        )}
                                    //  MenuProps={MenuProps}
                                    >
                                        <MenuItem value="">
                                            <em>Select</em>
                                        </MenuItem>
                                        {categoryList?.map(function (categoryList, i) {
                                            return <MenuItem key={categoryList} value={categoryList}>
                                                <Checkbox checked={categories.indexOf(categoryList) > -1} />
                                                <ListItemText primary={categoryList} />
                                            </MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} lg={6}>
                                <TextField fullWidth
                                    required
                                    label="Address"
                                    value={address}
                                    onChange={ (e) => onAddressChange(e)}
                                />
                            </Grid> */}
                            <Grid item xs={12} lg={12}>
                                <Box display='flex' justifyContent="flex-end" sx={{ pb: 2 }}>
                                    <Button sx={{ minWidth: 120 }} variant="contained" onClick={submit}>Submit</Button>
                                    &nbsp;
                                    &nbsp;
                                    <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined" component={RouterLink} to='../manage-helpdesk-user'>Cancel</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />
            <ConfirmationPopover onOpen={logConfirmModalOpen1} onConfirm={onConfirmUpdate} onClose={handleConfirmLogModalClose1} action="Submit" />
        </>
    )
}

export default AddEdituserPage